/* eslint-disable no-console */

import router from '../src/router'
import loadTaggedPosts from '../src/utils/loadTaggedPosts'
import deletePost from '../src/utils/deletePost'
import savePost from '../src/utils/savePost'
import get from '../src/utils/get'

export default {
    async login({commit}, response){
        commit('login', response);
        commit('message', 'Zalogowano')
    },
    authorize({commit}){
      const token = window.localStorage.getItem('token');
      const role = window.localStorage.getItem('role')
      const id = window.localStorage.getItem('id');

      const authData = {
        token: token,
        role: role,
        id: id,
      }
      if (token !== null) {
        commit('authorize', authData);
        return true;
      }
    },
    async loadPosts({commit, dispatch, state}){

        if(!state.noPosts){
          commit('loading', true);
          const page = state.page;
          const mediaType = state.mediaType;

          const response = await get(state.token, `posts/all/${page}?mediaType=${mediaType}`);

          if (response.status === 'error') {
            commit('message', response.message);
            commit('loading', false);
          } else if (response.message === "Expired token") {
            dispatch('expiredSession');
          } else if (response.length === 0) {
            commit('noPosts', true);
            commit('loading', false);
            return;
          } else {
            commit('loading', false);
            commit('loadPosts', response);
          }
        }
    },
    async getYears({commit, state}){
      const response = await get(state.token, 'posts/getYears');

      commit('getYears', response.years);
    },
    async loadYearPosts({commit, dispatch, state }, year){
      const page = state.page;
      const mediaType = state.mediaType;

      commit('setYear', year);

      const response = await get(state.token, `posts/year/${page}/${year}?mediaType=${mediaType}`);

      if(!state.noPosts){
        commit('loading', true);

        if (response.status === 'error') {
          commit('message', response.message);
          commit('loading', false);
        } else if (response.message === "Expired token") {
          dispatch('expiredSession');
        } else if (response.length === 0) {
          commit('noPosts', true);
          commit('loading', false);
          return;
        } else {
          commit('loading', false);
          commit('loadPosts', response);
        }
      }
    },
    async loadTaggedPosts({commit, dispatch, state}, tag){

        if(tag === undefined) {
          tag = state.tag;
        }

        const mediaType = state.mediaType;
        const response = await loadTaggedPosts(state.token, state.page, tag, state.year, mediaType);

        if(!state.noPosts){
          commit('loading', true);

          if (response.status === 'error') {
            commit('message', response.message);
            commit('loading', false);
          } else if (response.message === "Expired token") {
            dispatch('expiredSession');
          } else if (response.length === 0) {
            commit('noPosts', true)
            commit('loading', false);
            return;
          } else {
            commit('setTag', tag);
            commit('loading', false);
            commit('subPage', true);
            commit('loadPosts', response);
          }
        }

    },
    async savePost({commit, dispatch, state}, payload){
      const response = await savePost(state.token, payload, state.user.userId)

      if(response.status === 'error') {
        commit('message', response.message);
        commit('saving', false);
      } else if (response.message === "Expired token") {
        dispatch('expiredSession');
      } else {
        commit('saving', false);
        commit('savePost', response);
        commit('message', 'Dodano obrazek');
      }
    },
    async deletePost({commit, dispatch, state}, payload){
      const response = await deletePost(state.token, payload);

      if( response.status === 'error') {
        commit('message', response.message);
      } else if (response.message === "Expired token") {
        dispatch('expiredSession');
      } else {
        commit('deletePost', payload.postId);
      }
    },
    resetPosts({commit}){
      commit('resetPosts');
      commit('noPosts', false);
    },
    expiredSession({commit, dispatch}){
      commit('message', 'Twoja sesja wygasła. Zaloguj się ponownie');
      commit('loading', false);
      dispatch('logout');
      router.push('/');
    },
    logout({commit}){
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('id');
      commit('message', 'Wylogowano');
      commit('logout');
      router.push('/');
    },
    resetPage({commit}){
      commit('resetPage');
    },
    isYearPage({commit}, payload){
      commit('isYearPage', payload)
    },
    subPage({commit}, payload){
      commit('subPage', payload)
    },
    loading({commit}, payload){
      commit('loading', payload);
    },
    saving({commit}, payload){
      commit('saving', payload)
    },
    message({commit}, payload ){
      commit('message', payload)
    },
    noPosts({commit}, payload){
      commit('noPosts', payload)
    },
    getImageModalSrc({commit}, payload){
      commit('getImageModalSrc', payload)
    },
    closeImageModal({commit}){
      commit('closeImageModal');
    },
    resetYear({commit}){
      commit('resetYear');
    },
    pageType({commit}, payload){
      commit('pageType', payload);
    },
    resetState({commit}, payload){
      const {page, year} = payload;

      commit('noPosts', false);
      commit('message', '');
      commit('resetPosts');
      commit('resetPage');
      commit('pageType', page);
      if(year){
        commit('resetYear');
      }
    },
    setMediaType({commit, dispatch}, payload){
      commit('setMediaType', payload);
      commit('noPosts', false);
      commit('resetPosts');
      commit('resetPage');
      dispatch('loadPosts');
    }
  }